import React from "react";

import HomePageContent from "../components/homePageContent";

const Home = () => {
  return <HomePageContent />;
};

export default Home;
